import { render, staticRenderFns } from "./ActivityPopcorn.vue?vue&type=template&id=05afa5da&"
import script from "./ActivityPopcorn.vue?vue&type=script&lang=js&"
export * from "./ActivityPopcorn.vue?vue&type=script&lang=js&"
import style0 from "./ActivityPopcorn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports